import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class ToggleSwitch extends BaseComponent {

	static get properties() {
		return {			
			checked: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		var toggleSwitch = this;	
		toggleSwitch.checked = false;
			
		setTimeout(function(){
			toggleSwitch.init();
		});
	}
	
	render() {	
		return html`
			<style>
				.switch {
				  position: relative;
				  display: inline-block;
				  width: 60px;
				  height: 34px;
				}

				.switch input { 
				  opacity: 0;
				  width: 0;
				  height: 0;
				}

				.slider {
				  position: absolute;
				  cursor: pointer;
				  top: 0;
				  left: 0;
				  right: 0;
				  bottom: 0;
				  background-color: #ccc;
				  -webkit-transition: .4s;
				  transition: .4s;
				}

				.slider:before {
				  position: absolute;
				  content: "";
				  height: 26px;
				  width: 26px;
				  left: 4px;
				  bottom: 4px;
				  background-color: white;
				  -webkit-transition: .4s;
				  transition: .4s;
				}

				input:checked + .slider {
				  background-color: #04aa6d;
				}

				input:focus + .slider {
				  box-shadow: 0 0 1px #04aa6d;
				}

				input:checked + .slider:before {
				  -webkit-transform: translateX(26px);
				  -ms-transform: translateX(26px);
				  transform: translateX(26px);
				}

				/* Rounded sliders */
				.slider.round {
				  border-radius: 34px;
				}

				.slider.round:before {
				  border-radius: 50%;
				}				
			</style>
			<label class="switch">				
			  <input itemid="cb" type="checkbox" />
			  <span class="slider round"></span>
			</label>				
		`;
	}
	
	init() {
		var toggleSwitch = this;
		
		var cb = ElementUtil.query(toggleSwitch, 'cb');		
		cb.addEventListener('click', function(e){			
			if (toggleSwitch.checked) {
				toggleSwitch.checked = false;
			} else {
				toggleSwitch.checked = true;
			}
		
			var clickEvent = new CustomEvent('value-change', { detail: {						
				value: toggleSwitch.checked
			}});
			toggleSwitch.dispatchEvent(clickEvent);		
		});
		
		if (toggleSwitch.checked) {
			cb.checked = true;		
		}
		
	}
	
	getValue() {
		var toggleSwitch = this;		
		return toggleSwitch.checked;
	}
	
	setValue(value) {
		var toggleSwitch = this;		
		toggleSwitch.checked = !value;
		
		var cb = ElementUtil.query(toggleSwitch, 'cb');
		if (toggleSwitch.checked) {
			cb.checked = true;		
		} else {
			cb.removeAttribute('checked');
		}	
	}
	
	getChecked() {
		var toggleSwitch = this;
		return (toggleSwitch.checked ? 'checked' : '');
	}
	
};
customElements.define('dl-toggle-switch', ToggleSwitch);


